/* eslint-disable */
import configStoresDiscount from './stores-discount.config.json'
import initializer from '@oliverstore/core-rendering-engine'

// Ajoute le scss lié à stores-discount
import './scss/storesdiscount.config.scss'

// Lance le core-rendering-engine
initializer(configStoresDiscount).startApplication({
  tags: [
    {
      value: 'olst',
      type: 'olst'
    }, {
      value: 'olst-gallery',
      type: 'olst-gallery'
    }
  ]
});



// WEBPACK FOOTER //
// ./src/main.js